/**
 * A text value with surrounding whitespace removed, or undefined when nothing
 * but whitespace is left.
 */
export function trimOrUndefined(value: string | undefined): string | undefined {
  return value?.trim() || undefined;
}
